import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="relative min-h-screen">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ 
          backgroundImage: "url('https://public.readdy.ai/ai/img_res/4720c25937ff7a1d4281119796accddb.jpg')"
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-[#4F8B3A]/95 via-[#4F8B3A]/85 to-transparent"></div>
      </div>

      {/* Navigation */}
      <nav className="relative z-20 bg-white/95 backdrop-blur-sm shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/2d70788572f3bf6ab3fc4009e4756eb5/7f9ed3602ae8058bafa044d085fa2086.png" 
                alt="AIRPURE Logo" 
                className="h-12 w-auto"
              />
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center space-x-8">
              <Link to="/" className="text-slate-700 hover:text-[#4F8B3A] transition-colors cursor-pointer whitespace-nowrap">
                Accueil
              </Link>
              <a href="#avantages" className="text-slate-700 hover:text-[#4F8B3A] transition-colors cursor-pointer whitespace-nowrap">
                Avantages
              </a>
              <a href="#solutions" className="text-slate-700 hover:text-[#4F8B3A] transition-colors cursor-pointer whitespace-nowrap">
                Nos Solutions
              </a>
              <a href="#financement" className="text-slate-700 hover:text-[#4F8B3A] transition-colors cursor-pointer whitespace-nowrap">
                Financement CEE
              </a>
              <a href="#processus" className="text-slate-700 hover:text-[#4F8B3A] transition-colors cursor-pointer whitespace-nowrap">
                Notre Processus
              </a>
              <a href="#contact" className="bg-[#0066A1] hover:bg-[#004A70] text-white px-6 py-2.5 rounded-lg font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap">
                Étude Gratuite
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button 
              className="lg:hidden p-2"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <i className={`text-2xl text-slate-800 ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="lg:hidden bg-white border-t border-slate-200 py-4">
              <div className="flex flex-col space-y-4">
                <Link to="/" className="text-slate-700 hover:text-[#4F8B3A] px-4 py-2 cursor-pointer">
                  Accueil
                </Link>
                <a href="#avantages" className="text-slate-700 hover:text-[#4F8B3A] px-4 py-2 cursor-pointer">
                  Avantages
                </a>
                <a href="#solutions" className="text-slate-700 hover:text-[#4F8B3A] px-4 py-2 cursor-pointer">
                  Nos Solutions
                </a>
                <a href="#financement" className="text-slate-700 hover:text-[#4F8B3A] px-4 py-2 cursor-pointer">
                  Financement CEE
                </a>
                <a href="#processus" className="text-slate-700 hover:text-[#4F8B3A] px-4 py-2 cursor-pointer">
                  Notre Processus
                </a>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-screen flex items-center">
        <div className="max-w-3xl">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Déshumidificateurs Serres – 100 % financés grâce à la CEE
          </h1>
          <p className="text-xl md:text-2xl text-white/95 mb-8 leading-relaxed">
            Stabilisez l'hygrométrie de votre serre, réduisez les maladies fongiques, diminuez vos coûts. <strong className="text-white">0 € d'avance.</strong>
          </p>
          <a 
            href="#contact" 
            className="inline-block bg-[#0066A1] hover:bg-[#004A70] text-white text-lg font-semibold px-10 py-4 rounded-lg transition-all duration-300 shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
          >
            Demander une étude gratuite
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white/60 animate-bounce z-10">
        <i className="ri-arrow-down-line text-2xl"></i>
      </div>
    </div>
  );
}
